.number {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--lp-spacing-200);
}
